<template>
    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">

        <div>
            <el-select v-if="paging"
                class="select-primary mb-3 pagination-select"
                v-model="paging.perPage"
                placeholder="Per page">

                <el-option
                    class="select-primary"
                    v-for="item in paging.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>

            </el-select>
        </div>

        <form @submit.prevent="submit">
            <base-input v-if="search">
                <el-input
                    type="search"
                    class="mb-3 search-input"
                    clearable
                    prefix-icon="el-icon-search"
                    :placeholder="$t('common.search')"
                    v-model="searchValue"
                    aria-controls="datatables"
                    @clear="submit">
                </el-input>
            </base-input>
        </form>

    </div>
</template>

<script>
    export default {

        props: {
            paging: {
                type: Object,
                required: false
            },
            search: {
                type: Boolean,
                default: false
            },
            value: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                searchValue: ''
            }
        },

        methods: {
            submit() {
                this.$emit('input', this.searchValue.trim())
            }
        }
    }
</script>
